<div class="shm-heading">
    <div class="k-d-inline-flex">
        <h2 class="k-mb-6">
            Close a Request for <span *ngIf="isAdditional">Additional </span>Reevaluation
        </h2>
    </div>
</div>
<form class="" [formGroup]="form">
    <div>

        <div class="contact-details k-my-4">
            <div class="k-d-inline-flex k-mb-2">
                <h3 class="k-m-0" id="closedReasonLabel">Closed Reason</h3>
            </div>
            <div class="k-d-flex k-justify-content-stretch">
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                    <kendo-textbox formControlName="note" aria-labelledby="closedReasonLabel"></kendo-textbox>
                </div>
            </div>
        </div>

        <div class="contact-details k-my-4">
            <div class="k-d-inline-flex ">
                <h3 class="k-m-0" id="dateClosedLabel"> Date Closed</h3>
            </div>
            <div class="k-d-flex k-justify-content-stretch">
                <div class="k-ml-2 k-mr-2 k-mb-2 k-w-full">
                    <kendo-datepicker calendarType="classic" rounded="large" formControlName="date"
                        placeholder="MM/DD/YYYY" [format]="format" aria-labelledby="dateClosedLabel"></kendo-datepicker>
                </div>
            </div>
        </div>
    </div>
</form>
<div class="page-footer k-mt-2 k-text-right">
    <div class="action-btns">
        <div class="action-btns__right">
            <button kendoButton size="large" rounded="large" fillMode="outline" themeColor="error" (click)="onCancel()">
                Close
            </button>
            &nbsp;
            <button kendoButton themeColor="primary" (click)="submit()" size="large" rounded="large" fillMode="solid">
                Submit
            </button>
        </div>
    </div>
</div>